<ng-container *ngIf="innerHtmlContent">
    <div [innerHTML]="innerHtmlContent"></div>
</ng-container>

